// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3uMk6","title":"InfoRow_title__3j33x"};